import axios from "axios";

const fallbackBackendUrl = typeof window !== "undefined" ? window.location.origin : "";
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || fallbackBackendUrl).replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dl_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Team analytics default to the newest/current Deadlock patch. A user's
  // explicit selection persists across every team analytics page.
  const isTeamAnalytics = config.method?.toLowerCase() === "get"
    && /^\/teams\/[^/]+$/.test(String(config.url || ""));
  if (isTeamAnalytics) {
    const patch = localStorage.getItem("dl_patch_filter") || "current";
    // An explicit patch (e.g. the previous-patch comparison) wins over the stored choice.
    config.params = { patch, ...(config.params || {}) };
  }
  return config;
});

export default api;
